module.exports = __webpack_public_path__ + "static/web-unapproved-network-syndication-5eefc963b2328b287b9729ee4214c1d4.gif";